import {ThemeName, ThemeProvider} from '@volkswagen-onehub/components-core'
import React from 'react'
import {getCurrentThemeVariant} from './themeVariant'

interface ThemedLayerProviderProps {
    children: React.ReactNode
    theme?: ThemeName
}

export function ThemedLayerProvider(
    props: ThemedLayerProviderProps
): React.JSX.Element {
    return (
        <ThemeProvider
            theme={props.theme ?? 'main'}
            variant={getCurrentThemeVariant()}
        >
            {props.children}
        </ThemeProvider>
    )
}
